// extracted by mini-css-extract-plugin
module.exports = {"link":"ActionLink_link__pp7sM"};